import {Syndicates} from "modules/utils/enums";

export const MAIN_COLOUR = process.env.REACT_APP_MAIN_COLOUR || "#1B48E0";
export const LADDER_HEADING_COLOUR =
	process.env.REACT_APP_LADDER_HEADER_COLOUR || "#000";
export const SPONSOR_LEAGUE_COLOUR =
	process.env.REACT_APP_SPONSOR_LEAGUE_COLOUR || "#000";
export const HOME_ACTION_BUTTON_BG =
	process.env.REACT_APP_HOME_ACTION_BUTTON_BG || "#000";
export const LEAGUE_BUTTON_HOVER =
	process.env.REACT_APP_LEAGUE_BUTTON_HOVER || null;
export const PICK_COLOUR = process.env.REACT_APP_PICK_COLOUR || "#d1ebfd";
export const GAME_NAME = process.env.REACT_APP_GAME_NAME;

export const HEADER_BACKGROUND = process.env.REACT_APP_HEADER_BACKGROUND || "";
export const RADIO_COLOUR = process.env.REACT_APP_RADIO_COLOUR || MAIN_COLOUR;
export const ODDS_BACKGROUND = process.env.REACT_APP_ODDS_BACKGROUND || "";

export const IS_UK = GAME_NAME === "UK";
export const IS_AU = GAME_NAME === "Tabcorp";

export const IS_DE = [Syndicates.DE, Syndicates.DE_RTL].includes(
	GAME_NAME as Syndicates
);
export const IS_RTL = GAME_NAME === "RTL";
console.log(process.env.REACT_APP_SYNDICATE, IS_RTL);
export const ODDS_PARTNER_KEY = process.env.REACT_APP_ODDS_PARTNER_KEY || "";

export const PICKS_STORAGE_KEY = "picks";

export const FB_ID = process.env.REACT_APP_FACEBOOK_APP_ID || "";
export const IS_LOCAL = JSON.parse(process.env.REACT_APP_IS_LOCAL || "false");
